import script from "./VInputEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./VInputEditor.vue?vue&type=script&lang=ts&setup=true"

import "./VInputEditor.vue?vue&type=style&index=0&id=43ebf3ce&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ebf3ce"]])

export default __exports__